/**
 * MinimiseHint — «сверните, а не закрывайте», once.
 *
 * Task 07. `spec.md` «Плеер»: «Подсказка в интерфейсе указывает на сворачивание, а не на
 * крестик. Фоновое воспроизведение в текстах никогда не обещается». Both halves are facts
 * about Telegram, checked in the old project against the clients' source: closing the Mini
 * App stops the music on both phones, and nothing can prevent it. So the sentence says what
 * the cross does and what to do instead — and deliberately says nothing about the music
 * going on in the background, because whether it does is the phone's decision, not ours.
 *
 * Shown under the mini player from the first track on, until «Понятно». The dismissal is
 * remembered on the phone; a page without storage simply shows the hint again next time.
 */

import type { JSX } from 'react';
import { useState } from 'react';

import { usePlayer } from '../store/player';

export const MINIMISE_HINT_TEXT =
  'Крестик закрывает плеер и останавливает музыку. Чтобы перейти в чат, сверните приложение.';
export const MINIMISE_HINT_LABEL = 'Понятно';

/** Where the dismissal is remembered. */
export const HINT_KEY = 'fdm:hint-minimise';

function dismissedBefore(): boolean {
  try {
    return localStorage.getItem(HINT_KEY) === '1';
  } catch {
    return false;
  }
}

export function MinimiseHint(): JSX.Element | null {
  const started = usePlayer((s) => s.track !== undefined);
  const [dismissed, setDismissed] = useState(dismissedBefore);

  if (!started || dismissed) return null;

  return (
    <p className="hint">
      <span>{MINIMISE_HINT_TEXT}</span>
      <button
        type="button"
        className="linkButton"
        onClick={() => {
          setDismissed(true);
          try {
            localStorage.setItem(HINT_KEY, '1');
          } catch {
            // Remembered for this launch only.
          }
        }}
      >
        {MINIMISE_HINT_LABEL}
      </button>
    </p>
  );
}
